export default __webpack_public_path__ + "static/media/f-11.79e9af0c.jpg";